module.exports = blogPostURLProcess;

function blogPostURLProcess(url) {
  return `/blog/${url.slice(11)}`;
}
